module.exports = __webpack_public_path__ + "static/media/lowellacademy.com.71820222.png";